'use client';
import { otherData } from '../../data';
import useOpenCloseToggle from '../../hooks/useOpenCloseToggle';
import ContentWrapper from '../ContentWrapper/ContentWrapper';
import LiveSupport from '../LiveSupportButton/LiveSupportButton';
import SectionTitle from '../SectionTitle/SectionTitle';
import SideNavItem from '../SideNavItem/SideNavItem';

const OtherSection = () => {
	const { open, toggleOpen } = useOpenCloseToggle();

	return (
		<>
			<SectionTitle title="Other" toggleOpen={toggleOpen} open={open} />
			<ContentWrapper open={open}>
				{otherData.map((item, index) => {
					return <SideNavItem key={index} {...item} />;
				})}
				<LiveSupport />
			</ContentWrapper>
		</>
	);
};

export default OtherSection;
